import { Schema as S, Schema } from 'effect';

import { Forename } from './domain/forename';
import { Password } from './domain/password';
import { Surname } from './domain/surname';
import { Boolean } from './primitive/boolean';
import { Email } from './primitive/email';
import { StringOptionalProperty } from './primitive/string';

/**
 * Login form data schema
 */
export const LoginFormSchema = S.Struct({
  email: Email,
  password: Password,
});

export type LoginFormData = S.Schema.Type<typeof LoginFormSchema>;

/**
 * Reset password request
 */
export const ResetPasswordFormSchema = S.Struct({
  email: Email,
});

export type ResetPasswordFormData = S.Schema.Type<typeof ResetPasswordFormSchema>;

/**
 * Newsletter subscription form
 */
export const NewsletterFormSchema = S.Struct({
  email: Email,
});

export type NewsletterFormData = S.Schema.Type<typeof NewsletterFormSchema>;

/**
 * Reset password after request with token
 */
export const ResetPasswordWithTokenFormSchema = S.Struct({
  email: StringOptionalProperty,
  password: Password,
});

export type ResetPasswordWithTokenFormData = S.Schema.Type<typeof ResetPasswordWithTokenFormSchema>;

/**
 * Registration form data schema
 */
export const RegistrationFormSchema = S.Struct({
  email: Email,
  //todo validation on client input - length, numbers, symbols etc.
  password: Password,
  firstName: Forename,
  lastName: Surname,
  subscribedToNewsletter: Schema.optional(Boolean),
});

export type RegistrationFormData = S.Schema.Type<typeof RegistrationFormSchema>;

/**
 * API format for login submission
 */
export type LoginApiFormat = {
  email: string;
  password: string;
};

/**
 * API format for registration submission
 */
export type RegistrationApiFormat = {
  email: string;
  password: string;
};

/**
 * Order placed registration form data schema (password only)
 */
export const OrderPlacedRegistrationFormSchema = S.Struct({
  password: Password,
  subscribedToNewsletter: Schema.optional(Boolean),
});

export type OrderPlacedRegistrationFormData = S.Schema.Type<
  typeof OrderPlacedRegistrationFormSchema
>;
